export default __webpack_public_path__ + "static/media/img-5.8395f0ae.jpg";